import { SelectInput } from "components/Select";
import { useFilterActions } from "../../../ducks/filter/hooks/actions";
import {
  useGetStoresOptionsQuery,
  useGetAnalystsOptionsQuery,
} from "../../../../../../services/analyst-assignment/select-options";
import { RoleEnum } from "../../../../../../enum/role";
import { useRegionalsOptions } from "../../../ducks/filter/hooks/use-regionals-options";
import { StatusEnum } from "@/enum/status";

export default function SelectFilters() {
  const { updateFilter } = useFilterActions();

  const { data: storeOptions } = useGetStoresOptionsQuery();
  const { data: analystsOptions } = useGetAnalystsOptionsQuery({
    role: RoleEnum.ANALISTA,
  });

  const { options: regionalOptions } = useRegionalsOptions(
    StatusEnum.ACTIVE,
    999
  );

  const handleSelectStoreChange = (
    option: any | { value: string; label: string }
  ) => {
    updateFilter({ key: "code", value: option?.value });
    updateFilter({ key: "meta", value: { page: 1 } });
  };

  const handleSelectAnalystChange = (
    option: any | { value: string; label: string }
  ) => {
    updateFilter({ key: "responsible", value: option?.value });
    updateFilter({ key: "meta", value: { page: 1 } });
  };

  const handleSelectRegionalChange = (
    option: any | { value: string; label: string }
  ) => {
    updateFilter({ key: "regional", value: option?.value });
    updateFilter({ key: "meta", value: { page: 1 } });
  };

  const filtersData = [
    {
      options: storeOptions,
      placeholder: "Selecionar loja",
      onChange: handleSelectStoreChange,
      className: "select-filter",
      classNamePrefix: "an-simple-select",
    },
    {
      options: analystsOptions,
      placeholder: "Selecionar responsável",
      onChange: handleSelectAnalystChange,
      className: "select-filter",
      classNamePrefix: "an-simple-select",
    },
    {
      options: regionalOptions,
      placeholder: "Selecionar regional",
      onChange: handleSelectRegionalChange,
      className: "select-filter",
      classNamePrefix: "an-simple-select",
    },
  ];

  return (
    <>
      {filtersData.map((filter) => (
        <SelectInput
          key={filter.placeholder}
          options={filter.options}
          placeholder={filter.placeholder}
          onChange={filter.onChange}
          className={filter.className}
          classNamePrefix={filter.classNamePrefix}
          isClearable
        />
      ))}
    </>
  );
}
